import axios, { AxiosError } from 'axios';
import { api } from '@/lib';

export const api2 = axios.create({
  baseURL: 'https://dm-quizzes.azurewebsites.net/api',
});

export const getQuizzes = async () => {
  try {
    const res = await api.get('quizz/by-paciente');
    return res.data.data;
  } catch (error) {
    console.log('erro', error);
    return error;
  }
};

export const fetchTrigger = async (
  publicacaoId: string,
  protocoloId: string,
) => {
  try {
    const quizzes = await api2.post(
      `app/publicacao/enviar-publicacao?publicacaoId=${publicacaoId}&ProtocoloId=${protocoloId}`,
    );

    return quizzes?.data;
  } catch (err) {
    if (err instanceof AxiosError) {
      return err?.response?.data?.error?.message;
    }
    return 'Ocorreu um erro, tente novamente mais tarde';
  }
};

export const postRespostas = async (payload: any) => {
  try {
    const res = await api2.post('/app/questionario-cliente/responder', payload);
    return res;
  } catch (error) {
    return error;
  }
};

export const getQuizzesPerguntas = async (id: any) => {
  try {
    const res = await api2.get(`/app/questionario-cliente/pergunta/${id}`);

    return res.data;
  } catch (error) {
    return error;
  }
};
